const CONTACT_EMAIL = "haemoperation@gmail.com";
const CONTACT_PHONE_NUMBER = "05360163818";

export const AppConstant = {
    CONTACT_ADDRESS: "201 C,Balaji Hall ,150ft ring road, Rajkot, 360005",
    CONTACT_EMAIL,
    MAIL_TO_EMAIL: `mailto:${CONTACT_EMAIL}`,
    CONTACT_PHONE_NUMBER,
    CALL_PHONE_NUMBER: `tel:+${CONTACT_PHONE_NUMBER}`,
    FACEBOOK_LINK: "https://facebook.com",
    INSTA_LINK: "https://www.instagram.com/hemoperasyon/?igsh=MWE3OWo2eWdyd2s3Zg%3D%3D&utm_source=qr#",
}